import { type } from './menuStateActions';

export const menuStateReducer = (state = {}, action) => {
  switch (action.type) {
    case type.changeOpen:
      return {
        ...state,
        open: action.payload,
      };

    default:
      return state;
  }
};
